const mixins = {
    data() {
        return {
            baseUrl: '',
            // baseUrl: 'http://cqsjxw.cyberinner.vip:10000'
            // baseUrl: 'http://cyberinner.vip:8011'
            // baseUrl: 'http://192.168.31.154:8011'
        }
    },
    methods: {
        goUrl(url) {
            this.$router.push(url)
        },
        changeChannelIndex(url) {
            if(url === '/') {
                this.$store.dispatch('setActiveIndex', 0)
            } else {
                let navbarList = this.$store.state.navbar.navbarList
                for(let i=0; i<navbarList.length; i++) {
                    if(navbarList[i].url === url) {
                        this.$store.dispatch('setActiveIndex', i)
                        break
                    }
                }
            }
        },
        getDetailParams() {
            let params = {parentNavName: '', parentUrl: '', childrenNavName: ''}
            let navbarList = this.$store.state.navbar.navbarList
            let channelId = parseInt(this.$route.query.channelId)
            one: for(let parentItem of navbarList) {
                if(parentItem.meta.id === channelId) {
                    params.parentNavName = parentItem.meta.title
                    params.parentUrl = parentItem.url
                    break
                } else if(parentItem.children.length > 0) {
                    for(let childrenItem of parentItem.children) {
                        if(childrenItem.id === channelId) {
                            params.parentNavName = parentItem.meta.title
                            params.childrenNavName = childrenItem.title
                            params.parentUrl = parentItem.url
                            break one;
                        }
                    }
                }
            }
            return params
        },
        getRadioDetailParams() {
            let params = {id: '', contentType: '', radioTypeName: ''}
            let id = parseInt(this.$route.query.id)
            let contentType = parseInt(this.$route.query.contentType)
            let radioTypeName = this.$route.query.radioTypeName
            params.id = id
            params.contentType = contentType
            if(isNaN(id) || id === undefined || Math.floor(id) != id) {
                return;
            }
            if(isNaN(contentType) || contentType === undefined || Math.floor(contentType) != contentType) {
                return;
            }
            if(radioTypeName !== undefined && radioTypeName !== '') {
                params.radioTypeName = radioTypeName
            }
            return params
        },
        getChannelParams() {
            let params = {parentNavName: '', parentUrl: '', childrenNavName: '', subChannelList: [], currentSubChannelId: undefined}
            let currentPath = this.$route.path.split('?')[0]
            let navbarList = this.$store.state.navbar.navbarList
            if(this.$route.query.channelId !== undefined) {
                params.currentSubChannelId = parseInt(this.$route.query.channelId)
            } else {
                params.currentSubChannelId = this.$route.query.channelId
            }
            for(let parentItem of navbarList) {
                if(parentItem.url === currentPath) {
                    params.parentNavName = parentItem.meta.title
                    params.parentUrl = parentItem.url
                    params.parentChannelId = parentItem.meta.id
                    if(parentItem.children.length > 0) {
                        for(let childrenItem of parentItem.children) {
                            params.subChannelList.push({id: childrenItem.id, title: childrenItem.title})
                            if(childrenItem.id === params.currentSubChannelId) params.childrenNavName = childrenItem.title
                        }
                        if(params.currentSubChannelId === undefined) params.childrenNavName = params.subChannelList[0].title
                    } else {
                        params.childrenNavName = ''
                    }
                    break
                }
            }
            if(params.currentSubChannelId === undefined && params.subChannelList.length > 0) {
                params.currentSubChannelId = params.subChannelList[0].id
            }
            return params
        },
        getTypeNavParams() {
            let navParams = {parentNavName: '', parentUrl: '', childrenNavName: '', subChannelList: []}
            let currentPath = this.$route.path.split('?')[0]
            let navbarList = this.navbarList
            if(currentPath === '/details') {
                let channelId = parseInt(this.$route.query.channelId)
                one: for(let parentItem of navbarList) {
                    if(parentItem.meta.id === channelId) {
                        navParams.parentNavName = parentItem.meta.title
                        navParams.parentUrl = parentItem.url
                        break
                    } else if(parentItem.children.length > 0) {
                        for(let childrenItem of parentItem.children) {
                            if(childrenItem.id === channelId) {
                                navParams.parentNavName = parentItem.meta.title
                                navParams.childrenNavName = childrenItem.title
                                navParams.parentUrl = parentItem.url
                                break one;
                            }
                        }
                    }
                }
            } else {
                let channelId = parseInt(this.$route.query.channelId)
                for(let parentItem of navbarList) {
                    if(parentItem.url === currentPath) {
                        this.parentNavName = parentItem.meta.title
                        this.parentUrl = parentItem.url
                        if(parentItem.children.length > 0) {

                            if(channelId === undefined) {
                                this.childrenNavName = parentItem.children[0].title
                            } else {
                                for(let childrenItem of parentItem.children) {
                                    if(childrenItem.id === channelId)
                                        this.childrenNavName = childrenItem.title
                                }
                            }
                        }
                        break
                    }
                }
            }
        },
    }
}

export default mixins
